import React from 'react';
import { Calendar, Mail, Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const profileImage = "https://customer-assets.emergentagent.com/job_7c423f73-9f5b-4113-8588-fe3aec689b04/artifacts/uau7vv0s_IMG_4650.png";

  const handleBookConsultation = () => {
    window.open('https://calendly.com/digitalcoachshyam/startegy-call', '_blank');
  };

  const handleContact = (type) => {
    if (type === 'email') {
      window.location.href = 'mailto:digitalcoachshyam@gmail.com';
    } else if (type === 'phone') {
      window.location.href = 'tel:+919867809539';
    } else if (type === 'whatsapp') {
      const message = encodeURIComponent('Hi! I came across your Digital Shyaam website and would like to discuss my marketing needs.');
      window.open(`https://wa.me/919867809539?text=${message}`, '_blank');
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-6xl md:text-7xl font-bold leading-tight" style={{ fontFamily: "'Crimson Text', serif" }}>
                Growth &<br />Performance<br />Marketing Expert
              </h1>
              <p className="text-xl text-gray-700 leading-relaxed">
                Transforming businesses through data-driven digital marketing strategies.
                <span className="block mt-2 font-semibold">8 years of excellence. 500+ successful projects.</span>
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={handleBookConsultation}
                className="bg-black text-white hover:bg-gray-800 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg"
              >
                <Calendar className="mr-2 h-5 w-5" />
                Book a Consultation
              </Button>
              <Button 
                onClick={() => handleContact('whatsapp')}
                className="bg-[#25D366] text-white hover:bg-[#20BA5A] px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                Chat on WhatsApp
              </Button>
            </div>

            <div className="flex gap-6 pt-4">
              <button 
                onClick={() => handleContact('phone')}
                className="flex items-center gap-2 text-gray-700 hover:text-black transition-colors duration-200"
              >
                <Phone className="h-5 w-5" />
                <span className="font-medium">+91 98678 09539</span>
              </button>
              <button 
                onClick={() => handleContact('email')}
                className="flex items-center gap-2 text-gray-700 hover:text-black transition-colors duration-200"
              >
                <Mail className="h-5 w-5" />
                <span className="font-medium">Email Us</span>
              </button>
            </div>
          </div>

          {/* Right Column - Profile Image */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-[400px] h-[400px] rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={profileImage}
                  alt="Shyaam - Performance Marketing Expert"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Credential Badge */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 border-2 border-black">
                <p className="text-sm font-semibold text-gray-600">Masters in Digital Marketing</p>
                <p className="text-lg font-bold text-black">Purdue University</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
